'use strict'

export default class Batch {
	constructor(injections, plateToInjectionsMap, injectionNameToIdsMap, aliases, injectionsMap) {
		this._injections = injections;
		this._plateToInjectionsMap = plateToInjectionsMap;
		this._substanceAliases = aliases;
		this._injectionNameToIdsMap = injectionNameToIdsMap;
		this._injectionsMap = injectionsMap;
	}

	getAliases(){
		return this._substanceAliases
	}

	/** @returns {InjectionRow[]} */
	getInjections(){
		return this._injections;
	}

	/**
	 * @returns {Map<string, InjectionRow>}
	 */
	getInjectionsMap(){
		return this._injectionsMap;
	}

	/**
	 * @param {string} substanceAlias
	 * @returns {string[]}
	 */
	getInjectionIdsContainingSubstance(substanceAlias) {
		const lowerCaseAlias = substanceAlias.toLowerCase();
		return this._injections
			.filter(i => i.substances.find(s => s.displayName.toLowerCase() === lowerCaseAlias))
			.map(r=>r.getId());
	}

	/**
	 * @param {string} name
	 * @returns {string[]}
	 */
	getInjectionIdsByName(name){
		return this._injectionNameToIdsMap.get(name);
	}

	getInjectionsByPlateId(plateId) {
		return this._plateToInjectionsMap.get(plateId);
	}

	getInjectionById(id){
		return this._injections.find(r=>r.injection.id === id)
	}

	/**
	 * @param {InjectionRow[]} injections
	 * @returns {Batch}
	 */
	static create(injections) {
		const aliases = new Map();
		const plateToInjectionsMap = new Map();
		const injectionNameToIdsMap = new Map();
		/** @type {Map<string, InjectionRow>} */
		const injectionsMap = new Map();
		for (const injection of injections) {
			for (const substance of injection.substances) {
				aliases.set(substance.displayName.toLowerCase(), substance.displayName)
			}
			const plateId = injection.injection.plateId;
			const name = injection.injection.name;
			if (!plateToInjectionsMap.has(plateId)) {
				plateToInjectionsMap.set(plateId, []);
			}
			if (!injectionNameToIdsMap.has(name)) {
				injectionNameToIdsMap.set(name, []);
			}
			plateToInjectionsMap.get(plateId).push(injection);
			injectionNameToIdsMap.get(name).push(injection.getId());
			injectionsMap.set(injection.getId(), injection);
		}
		return new Batch(injections, plateToInjectionsMap, injectionNameToIdsMap, [...aliases.values()], injectionsMap);
	}
}


